module.exports = __webpack_public_path__ + "img/kevin1.41714dd2.jpeg";